import React from 'react';
import { McpProxyFormData, ValidationResult } from '../types';

interface RestApiTabProps {
  formData: McpProxyFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  validationResult: ValidationResult | null;
  validating: boolean;
  handleValidate: () => Promise<void>;
}

export const RestApiTab: React.FC<RestApiTabProps> = ({
  formData,
  handleChange,
  validationResult,
  validating,
  handleValidate,
}) => {
  return (
    <>
      <div className="form-group">
        <label htmlFor="openapi_spec">
          OpenAPI Specification (YAML) <span className="text-danger">*</span>
        </label>
        <textarea
          className="form-control font-monospace"
          id="openapi_spec"
          name="openapi_spec"
          value={formData.openapi_spec}
          onChange={handleChange}
          required
          rows={15}
          style={{ fontSize: '0.875rem' }}
          placeholder={`openapi: 3.0.0
info:
  title: My API
  version: 1.0.0
paths:
  /items:
    get:
      summary: List items
      responses:
        '200':
          description: Success`}
        />
        <small className="form-text text-muted">
          Paste your OpenAPI 3.0 specification in YAML format
        </small>
      </div>

      <div className="form-group">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleValidate}
          disabled={validating || !formData.openapi_spec || !formData.base_url}
        >
          {validating ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Validating...
            </>
          ) : (
            <>
              <i className="fas fa-check-circle me-2"></i>
              Validate Specification
            </>
          )}
        </button>

        {validationResult && (
          <div className={`alert mt-3 ${validationResult.valid ? 'alert-success' : 'alert-danger'}`}>
            {validationResult.valid ? (
              <>
                <i className="fas fa-check-circle me-2"></i>
                <strong>Valid!</strong>
                {validationResult.tools_count !== undefined && validationResult.tools_count > 0 && (
                  <span> Found {validationResult.tools_count} tool(s).</span>
                )}
              </>
            ) : (
              <>
                <i className="fas fa-exclamation-triangle me-2"></i>
                <strong>Invalid:</strong> {validationResult.error}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default RestApiTab;
